export const riskTypeMap = {
	'1': 'General Risk',
	'2': 'Client Clinical Risk',
	'3': 'Client Non-Clinical Risk'
}

export const riskTypeOptions: { id: string, text: string }[] = Object.keys(riskTypeMap).map(riskTypeKey => ({ id: riskTypeKey, text: riskTypeMap[riskTypeKey] }));